<template>
  <div class="entryContainer">
    <ul class="infoBasic" v-if="detail != ''">
      <li>
        <label>姓名：</label>
        <p>{{ detail.name }}</p>
      </li>
      <li>
        <label>联系电话：</label>
        <p>{{ detail.phone }}</p>
      </li>
      <li>
        <label>来源类型：</label>
        <p>
          {{
            detail.resume_source_info.type == undefined
              ? ""
              : detail.resume_source_info.type
          }}
        </p>
      </li>
      <li>
        <label>来源渠道：</label>
        <p>{{ detail.resume_source_info.channel }}</p>
      </li>
      <li v-show="detail.resume_source_info.details != ''">
        <label>来源账号：</label>
        <p>{{ detail.resume_source_info.details }}</p>
      </li>
    </ul>
    <!-- 入职详情 -->
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      v-bind="layout"
    >
      <a-form-model-item label="项目" prop="project_id">
        <a-select
          @change="selectRole"
          style="width: 300px"
          v-model="ruleForm.project_id"
          showSearch
          :filterOption="filterOption"
        >
          <a-select-option
            v-for="element in proList"
            :key="element.id"
            :value="element.id"
            >{{ element.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="门店/区域/大仓" prop="shop_id">
        <a-select v-model="ruleForm.shop_id" style="width: 300px">
          <a-select-option
            v-for="element in shopList"
            :key="element.id"
            :value="element.id"
            >{{ element.name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="岗位" prop="role_id">
        <a-select
          v-model="ruleForm.role_id"
          style="width: 300px"
          mode="multiple"
        >
          <a-select-option
            v-for="element in roleList"
            :key="element.id"
            :value="element.id"
            >{{ element.role_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="入职日期" prop="entry_time">
        <a-date-picker v-model="ruleForm.entry_time" />
      </a-form-model-item>
      <a-form-model-item label="类型" prop="work_type">
        <a-radio-group v-model="ruleForm.work_type">
          <a-radio :value="1">长期工</a-radio>
          <a-radio :value="2">临时工</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        v-if="detail.is_identity == 2 && ruleForm.work_type == 2"
        label="身份证号"
        prop="idcard"
      >
        <a-input v-model="ruleForm.idcard" />
      </a-form-model-item>
      <a-form-model-item
        v-if="detail.is_identity == 2 && ruleForm.work_type == 2"
        label="银行名称"
      >
        <a-input v-model="ruleForm.bank_name" />
      </a-form-model-item>
      <a-form-model-item
        v-if="detail.is_identity == 2 && ruleForm.work_type == 2"
        label="银行卡号"
      >
        <a-input v-model="ruleForm.bank_card_number" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="entry_remark">
        <a-textarea
          rows="3"
          style="width: 300px"
          v-model="ruleForm.entry_remark"
        ></a-textarea>
      </a-form-model-item>
      <a-form-model-item
        class="submitStyle"
        :wrapper-col="{ span: 10, offset: 5 }"
      >
        <a-button @click="backPage">返回</a-button>
        <a-button type="primary" @click="submitForm">确定</a-button>
      </a-form-model-item>
    </a-form-model>
    <!-- 入职详情 end -->
  </div>
</template>
<script>
import axios from "axios";
let moment = require("moment");
moment().format();
export default {
  data() {
    return {
      detail: "",
      ruleForm: {
        project_id: "",
        shop_id: "",
        role_id: [],
        work_type: "",
        entry_time: "",
        entry_remark: "",
        idcard: "",
        bank_card_number: "",
        bank_name: ""
      },
      roleList: [],
      proList: [],
      shopList: [],
      rules: {
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        role_id: [
          {
            required: true,
            message: "请选择岗位",
            trigger: "change"
          }
        ],
        entry_time: [
          {
            required: true,
            message: "请选择入职日期",
            trigger: "change"
          }
        ],
        work_type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change"
          }
        ],
        idcard: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur"
          }
        ]
      },
      layout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      }
    };
  },
  props: {
    entryDetail: {}
  },
  mounted() {
    this.getDetail();
    // this.getRole(); //岗位列表
    this.getPro(); //项目列表
  },
  watch: {
    entryDetail() {
      this.getDetail();
      // console.log(  this.detail )
    }
  },
  methods: {
    getDetail() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Resume_New/myResumeDetail";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          resume_id: this.entryDetail.resume_id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.detail = res.data.data;
            // console.log(this.detail);
          }
        });
    },
    selectRole() {
      this.getRole();
      this.getShops(); //获取门店/大仓/区域
    },
    getShops() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/getShopListData";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        project_id: this.ruleForm.project_id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.shopList = res.data.data;
          // console.log(res.data.data);
        }
      });
    },
    getRole() {
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "role/getRoleByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          per_page: 10000,
          project_id: this.ruleForm.project_id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.roleList = res.data.data;
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.proList = res.data.data;
          // console.log(this.proList);
        }
      });
    },
    submitForm() {
      let _this = this;
      this.$confirm({
        title: "入职提示",
        content: "入职后员工来源无法更改，确定相关信息无误该员工入职玄鸟平台?",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          let url =
            _this.httpsBasic.url +
            _this.httpsBasic.resume +
            "Resume/resumeEntry";
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            project_id: _this.ruleForm.project_id,
            shop_id: _this.ruleForm.shop_id,
            role_id: JSON.stringify(_this.ruleForm.role_id),
            work_type: _this.ruleForm.work_type,
            entry_time: moment(_this.ruleForm.entry_time).format("YYYY-MM-DD"),
            entry_remark: _this.ruleForm.entry_remark,
            resume_id: _this.detail.resume_id,
            bank_card_number: _this.bank_card_number,
            idcard: _this.idcard,
            bank_name: _this.bank_name
          };
          // console.log(params);
          if (_this.work_type != 2) {
            delete params.idcard;
            delete params.bank_name;
            delete params.bank_card_number;
          }
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                _this.$message.success("入职成功");
                _this.handleReset();
                // _this.$router.push({ name: "resume" });
                _this.$emit("hideInEntry", true);
              } else {
                _this.$info({
                  title: "提示",
                  content: res.data.message
                });
              }
            })
            .catch(err => {
              _this.$message.error("服务器出错啦...");
            });
        }
      });
    },
    backPage() {
      this.$emit("hideInEntry", false);
    },
    handleReset() {
      this.$refs["ruleForm"].resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
.entryContainer {
  padding: 0 10% 50px;
  .submitStyle {
    margin-top: 30px;
    button {
      margin-right: 20px;
    }
  }
  h2 {
    font-weight: normal;
  }
  .infoBasic {
    padding: 10px 10px 0;
    margin: 10px 10% 20px;
    border: 1px dotted #ccc;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 500px;
    li {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;
      label,
      p {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  .edtryContent {
    margin-bottom: 20px;
    li {
      margin-bottom: 10px;
      > div {
        width: 200px;
        margin-right: 20px;
      }
      i {
        color: #f56c6c;
        font-style: normal;
        display: inline-block;
        // margin-right: 4px;
      }
      textarea {
        font-size: 14px;
        line-height: 20px;
        padding: 10px;
        display: inline-block;
        max-width: 200px;
        vertical-align: top;
      }
    }
  }
}
</style>
<style lang="less">
.entryContainer {
  .ant-form-item {
    margin-bottom: 10px;
  }
}
</style>
